import { COLORS, FONTS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');

  return {
    cardRoot: {
      borderRadius: 0,
      [minSm]: {
        borderRadius: 4,
      },
    },
    heading: {
      fontFamily: FONTS.SECONDARY,
      color: COLORS.GREEN,
      fontSize: '1.25rem',
      textAlign: 'center',
      fontWeight: 700,
      marginTop: 0,
    },
  };
};

export default styles;
